// @ts-nocheck
import React, { useState, useReducer, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  Paper,
  Chip,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Typography,
  Stack,
  IconButton,
} from '@mui/material';
import {
  Link as RouterLink,
  // LinkProps as RouterLinkProps,
  MemoryRouter,
  Link,
} from 'react-router-dom';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import DateRange from '@mui/icons-material/DateRange';
import TimeAgo from 'react-timeago'

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';

import CarCrashIcon from '@mui/icons-material/CarCrash'; // diag
import CableIcon from '@mui/icons-material/Cable'; // connect
import BoltIcon from '@mui/icons-material/Bolt'; // fw
import ArchitectureIcon from '@mui/icons-material/Architecture'; // calib
import FaceIcon from '@mui/icons-material/Face'; // fw
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';

import ArrowCircleDownTwoToneIcon from '@mui/icons-material/ArrowCircleDownTwoTone';
import DownloadForOfflineTwoToneIcon from '@mui/icons-material/DownloadForOfflineTwoTone';

import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import exporting from "highcharts/modules/exporting";
exporting(Highcharts);

// ************************************************************
// ************************************************************
// ************************************************************

const CHART_OPTIONS = {
  chart: {
    events: {      
    },
    zoomType: 'xy'
  },
  legend: {
    enabled: true,
    floating: false,
    verticalAlign: 'top',
    align:'left',
    borderWidth: 1,
    borderRadius: 5,
    backgroundColor: '#FFFFFF',
    layout: 'vertical',
    floating: true,
    align: 'left',
    verticalAlign: 'top',
    // x: 90,
    // y: 60,
    shadow: true
  },  
  rangeSelector: {
    buttons: [{
        type: 'second',
        count: 0.200,
        text: '0.2s'
      }, {
        type: 'second',
        count: 1,
        text: '1s'
      }, {
        type: 'second',
        count: 5,
        text: '5s'
      }, {
        type: 'all',
        text: 'All'
      }
    ],
    selected: 3,
    inputEnabled: false,
  },
  navigator: {
    xAxis: {
      title: {
        //text: 'ms'
      },
      allowDecimals: true,
      type: 'datetime',
      dateTimeLabelFormats: {
        millisecond: '%S.%L',
        second: '%S',
      },
      tickInterval: 500, 
      labels: {
        formatter: function() { return  this.value; },
        rotation : 0
      },
    },
  },
  xAxis: {
    title: {
      text: 'ms'
    },
    allowDecimals: true,
    type: 'datetime',
    dateTimeLabelFormats: {
      millisecond: '%S.%L',
      second: '%S',
    },
    tickInterval: 500,
    labels: {
      formatter: function(){ return  this.value; },                
      rotation : 0
    },            
  },
  yAxis: [
    { // yAxis 0 ----- LO METTO ANCHE SE NON LO USO ALTRIMENTI IL PRIMO ME LO ALLINEA MALE E VA SUL GRAFICO !!
      title:  { text:   '',          },//style: { color: Highcharts.getOptions().colors[2] } },
      labels: { format: ' ',  },//style: { color: Highcharts.getOptions().colors[2] } },
      //opposite: true,
      min: 0,
      max: 1,
    }, 
    { // yAxis 1
      title:  { text:   'rpm',          },//style: { color: Highcharts.getOptions().colors[2] } },
      labels: { format: '{value:.0f}',  },//style: { color: Highcharts.getOptions().colors[2] } },
      //opposite: true,
      min: 0,
      max: 6500,
      // scrollbar: {
      //   enabled: true,
      //   showFull: false
      // }
    }, 
    { // yAxis 2
      gridLineWidth: 0,
      title:  { text:   'V',         },//style: { color: Highcharts.getOptions().colors[0] } },
      labels: { format: '{value:0.1f}',    },//style: { color: Highcharts.getOptions().colors[0] } }
      opposite: true,
      min: 0,
      max: 15,
    }, 
    { // yAxis 3
      gridLineWidth: 0,
      title:  { text:   'mbar',     },//style: { color: Highcharts.getOptions().colors[1] } },
      labels: { format: '{value:.0f}',  },//style: { color: Highcharts.getOptions().colors[1] } },
      //opposite: true,
      min: 0,
      max: 3000,
    },
    { // yAxis 4
      gridLineWidth: 0,
      title:  { text:   'ms',     },//style: { color: Highcharts.getOptions().colors[1] } },
      labels: { format: '{value:.1f}',  },//style: { color: Highcharts.getOptions().colors[1] } },
      //opposite: true,              
      min: 0,
      max: 20,
    },
    { // yAxis 5
      gridLineWidth: 0,
      title:  { text:   'degC',     },//style: { color: Highcharts.getOptions().colors[1] } },
      labels: { format: '{value}',  },//style: { color: Highcharts.getOptions().colors[1] } },
      min: -50,
      max: 205,
      //opposite: true,              
    },
    { // yAxis 6
      gridLineWidth: 0,
      title:  { text:   'counter',     },//style: { color: Highcharts.getOptions().colors[1] } },
      labels: { format: '{value}',  },//style: { color: Highcharts.getOptions().colors[1] } },
      visible: false,
    }
  ],
  tooltip: {
    dateTimeLabelFormats: {
      millisecond: '%S.%L',
      second: '%S',
    },
    formatter: function() {
      var points = this.points,
      tooltipArray = ['<b>' + this.x + 'ms</b>']

      points.forEach(function(point, index) {
        var str = '<span style="color:{'+point.series.color+'}">'+point.series.name+'</span>: <b>'+point.y+' '+point.series.userOptions.unit+'</b> <br/>';
        tooltipArray.push(str);
      });
      return tooltipArray;
    },
    //pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> <br/>',
    //valueDecimals: 2,
    //split: true
  },
  series: [],  
  exporting: {
    enabled: true,    
  },
}

// ************************************************************
// ************************************************************
// ************************************************************

const b64toArray = (base64) => {
  var raw = window.atob(base64)
  var array = new Uint8Array(new ArrayBuffer(raw.length))
  for (var i = 0; i < raw.length; i++ ) 
      array[i] = raw.charCodeAt(i)
  return array.buffer;
}
function bToU32(b, offset) {
  return b[0+offset] + b[1+offset]*256 + b[2+offset]*256*256 + b[3+offset]*256*256*256
}
function bToU16(b, offset) {
  return b[0+offset] + b[1+offset]*256
}
function getHeader(b) {
  //console.log(b)
  var o = {
    random:          bToU32(b, 0),
    sector_rev:      b[4],
    last_index:      b[5],
    num_rows:        b[6],
    first_validated: b[7],
    ecu_time:        bToU32(b, 8),
    rows_crc:        bToU16(b, 12),
    header_checksum: bToU16(b, 14),
  }
  return o;
}
function getRow(b) {
  var o = {
    rpm:              bToU16(b, 0),
    reducer_temp:     b[3] - 50.0,
    rail_temp:        b[4] - 50.0,
    batt_voltage:     b[5] / 10.0,
    coll_press:       bToU16(b, 6),
    rail_press:       bToU16(b, 8),
    pinj_time:        (bToU16(b, 10)) / 1000,
    ginj_time:        (bToU16(b, 12)) / 1000,
    tank_level:       (b[14] * (5000 / 255)) / 1000,
  }
  // console.log("rail_temp", o.rail_temp)
  // console.log(b[4])
  // console.log("reducer_temp", o.reducer_temp)
  // console.log(b[3])
  return o;
}
function getRows(rows_buffer, last_index, num_rows) {        
  var MaxRowCount = 250
  var RecordStepMs = 40 // ms  
  var rows = []        
  var pos = last_index
  for (var i = 0; i < num_rows; i++)
  {
    if (++pos >= MaxRowCount) pos = 0
    //console.log(pos)
    var row_buffer = rows_buffer.slice((pos * 16), ((pos + 1) * 16))
    var row = getRow(row_buffer)
    row.ecu_time = -1 * (num_rows - i) * RecordStepMs
    row.i = i
    // if (i == 163)
    // {
    //   console.log(pos)
    //   console.log(row)
    //   console.log(row_buffer)
    // }
    rows.push(row)          
    ////console.log(row)
  }
  return rows        
}  
function getSeries(rows) {
  var series = []
  var d              

  d = rows.map(row => [ row.ecu_time, row.batt_voltage ])
  series.push( {type: 'line', yAxis: 2, name: 'Battery Voltage', data: d, unit:'V'} )
  
  d = rows.map(row => { return [ row.ecu_time, row.coll_press ] })              
  series.push( {type: 'line', yAxis: 3, name: 'Coll Pressure', data: d, unit:'mbar'} )
  
  d = rows.map(row => { return [ row.ecu_time, row.rail_press ] })
  series.push( {type: 'line', yAxis: 3, name: 'Rail Pressure', data: d, unit:'mbar'} )

  d = rows.map(row => { return [ row.ecu_time, parseFloat(row.ginj_time.toFixed(1)) ] })
  series.push( {type: 'line', yAxis: 4, name: 'Gas Injection Time', data: d, unit:'ms'} )
  
  d = rows.map(row => { return [ row.ecu_time, parseFloat(row.pinj_time.toFixed(1)) ] })
  series.push( {type: 'line', yAxis: 4, name: 'Petrol Injection Time', data: d, unit:'ms'} )

  d = rows.map(row => { return [ row.ecu_time, row.rail_temp ] })
  series.push( {type: 'line', yAxis: 5, name: 'Rail Temperature', data: d, unit:'degC'} )

  d = rows.map(row => { return [ row.ecu_time, row.reducer_temp ] })
  series.push( {type: 'line', yAxis: 5, name: 'Reducer Temperature', data: d, unit:'degC'} )
  
  d = rows.map(row => { return [ row.ecu_time, row.rpm ] })
  series.push( {type: 'line', yAxis: 1, name: 'RPM', data: d, unit:'min-1'} )

  d = rows.map(row => { return [ row.ecu_time, parseFloat(row.tank_level.toFixed(3)) ] })
  series.push( {type: 'line', yAxis: 2, name: 'Tank Level', data: d, unit:'V'} )

  return series
}

// ************************************************************
// ************************************************************
// ************************************************************

export const EcuDiagChartComponentWrapper = (props) => {
  const { diag_buffer_id } = useParams()
  const navigate = useNavigate()
  return <EcuDiagChart
    diag_buffer_id={diag_buffer_id}
    navigate={navigate}
    {...props}
  />
}

export default class EcuDiagChart extends React.Component {
  constructor(props) {    
    super(props)
    this.state = { 
      loaded: false,
      chart_options: CHART_OPTIONS,
      current_diag_buffer_id: this.props.diag_buffer_id,
    }
  }
  componentDidMount() {
    this.loadDiagBuffer(this.props.diag_buffer_id)    
  } 
  componentDidUpdate() {
    if (this.state.current_diag_buffer_id != this.props.diag_buffer_id) {
      this.loadDiagBuffer(this.props.diag_buffer_id)    
    }
  } 
  loadDiagBuffer(diag_buffer_id) { 
    this.setState({
      loaded: false,
      current_diag_buffer_id: diag_buffer_id,
    })
    AuthService.getDiagBuffer(diag_buffer_id).then(data => { 
      if (data.value && data.value.header) {
        ///console.log(data.value.header)
        var header_buffer = new Uint8Array(b64toArray(data.value.header))
        var header = getHeader(header_buffer);
        console.log("header", header)
        var rows_buffer = new Uint8Array(b64toArray(data.value.rows))
        var rows = getRows(rows_buffer, header.last_index, header.num_rows)                
        const chart_options = { ...this.state.chart_options }
        chart_options.series = getSeries(rows)        
        console.log(chart_options) 
        ///console.log("rows", rows)
        this.setState({
          loaded: true,
          header: header,
          rows: rows,
          ecu_id: data.value.ecu_id,
          insert_date: data.value.insert_date,
          chart_options: chart_options,
        })        
      } else {
        console.error("Data or header is undefined")
      }
    }).catch(error => {
      console.error("Error fetching diag buffer:", error);
    })
  }
  render() {
    if (!this.state.loaded) return <LoadingSpinner />
    if (this.state.rows.length === 0) return <>NO INFO</>
    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    if (this.props.navbarHeight === undefined) height = "calc(100vh - 100px)"
    return (
      <>          
        <Box sx={{ height: {height}, border: '0px dashed grey' }}>
          <HighchartsReact
            containerProps={{ style: { height: "100%" } }}
            highcharts={Highcharts}
            constructorType={'stockChart'}
            options={this.state.chart_options}
            />
        </Box>
      </>
    )
  }
}

